<template>
  <div class="menuBody">
     <ReportTree @ReportTree="getMsgFormSon"/>
        <!-- <DailyChargeDialog :param="diaLogData" ref="DailyChargeDialog"/> -->
    <div class="menuTool" style="width:100%;">
      <el-card class="box-card">
        <el-row :gutter="0">
            <div style="width:100%;height:30px;margin-top:10px;border-bottom:1px solid rgba(234, 237, 241, 1);margin-bottom:15px">
                日收款汇总列表
              <div style="float:right;margin-right:10px;margin-top:-10px">
                <el-button type="primary"  size="small" plain  style="background: #38A38A;color:#fff;border-radius:9px;" v-Jurisdiction="'expense:web:cr:dailyCs:collectReport'" @click="Create()">生成报表</el-button>
              </div>
            </div>
            <div style="width:170px;float:left;margin-right:15px;margin-bottom:10px">
                <el-select  clearable v-model="Chargevalue" placeholder="请选择收费项目" multiple  collapse-tags size="small" @change="ChargevalueList">
                    <el-option v-for="item in ChargeItemList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
                          <div style="width:220px;float:left;margin-right:15px">
                   <el-date-picker
                      size="small"
                      style="width:220px;float:left;"
                      v-model="DateTime"
                      type="daterange"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="BillDateTime()">
                    </el-date-picker>
              </div>
                <div style="width:170px;float:left;margin-right:15px;margin-bottom:10px">
                <el-select  clearable v-model="value" placeholder="请选择凭证"  size="small" @change="InvoiceTy(value)">
                    <el-option v-for="item in invoiceType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </div>
  <el-table tooltip-effect="light"  :data="tableData"  :span-method="objectSpanMethod"   v-loading="loading" 
  @selection-change="handleSelectionChange"    style="overflow-y: scroll;float:right;margin-top:30px" 
  row-key="id"   :default-expand-all="false"  :header-cell-style="{background:'#eef1f6',color:'#606266','font-weight': '600','height':'45px','text-align':'left'}" 
      :cell-style="{'text-align':'left'}" :stripe="true" :tree-props="{children: 'children'}">
    <el-table-column show-overflow-tooltip prop="projectName" label="管理处"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="feeName" label="收费项目"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.现金" label="现金"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.微信" label="微信"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.pos机" label="pos机"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.通联（支付宝）" label="通联（支付宝）"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.银行转账" label="银行转账"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.支付宝" label="支付宝"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.微信支付" label="微信支付"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.押金转账" label="押金转账"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.银行划扣" label="银行划扣"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.其他" label="其他"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.APP" label="APP"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.刷卡" label="刷卡"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.通联（微信）" label="通联（微信）"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.转账" label="转账"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.导入" label="导入"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.转冲" label="转冲"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.银联划账" label="银联划账"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.B2B" label="B2B"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.minipay" label="minipay"  ></el-table-column>
    <el-table-column show-overflow-tooltip prop="map.现金+刷卡" label="现金+刷卡"  ></el-table-column>
  </el-table>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
// import DailyChargeDialog from "../common/DailyChargeDialog";
import ReportTree from "./ReportTree.vue";

export default {
  name: "CollectionDayGather",
  components: {ReportTree},
  data() {
    return {
      loading:false,
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面
        diaLogVisible: false,
        AllData:"",
        tableData:[],
        coplistArr:[],
        melistArr:[],
        DayCollectArr:[],
        object:{},
        DateTime:"",
        value:"",
        invoiceType:[{
          value:"1",
          label:"是",
        },{
          value:"2",
          label:"否",
        }],

        ChargeItemList:[],
        Chargevalue:"",
        projectIds:[],
        CheckArr:[],

    }  
  },
  methods: {
    handleSelectionChange(val){
    },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 0) {
          if (rowIndex % 2 === 0) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },
    Derive(){

    },
    BillDateTime(time){
      var d = this.DateTime[0]
      	let year = d.getFullYear();
	    	let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1 ): d.getMonth() + 1
	    	let dates = d.getDate()< 10 ? '0' +d.getDate() : d.getDate()
       var ds = this.DateTime[1]
      	let years = ds.getFullYear();
	    	let months = ds.getMonth() + 1 < 10 ? '0' + (ds.getMonth() + 1 ): ds.getMonth() + 1
	    	let datess = ds.getDate()< 10 ? '0' +ds.getDate() : ds.getDate()
      this.fromDate = year+"-"+month+"-"+dates
      this.toDate = years+"-"+months+"-"+datess
      // console.log(this.fromDate,this.toDate)
    },
    Create(){
      this.loading = true
        this.ShareList()
    },
     getMsgFormSon(data){
        if(data.chack == false){
for (var i = 0; i < this.CheckArr.length; i++) {
            if ((this.CheckArr[i].id).indexOf(data.object.id) > -1) {//判断key为999的对象是否存在，
               var index = i;
                this.CheckArr.splice(index, 1);//存在即删除
            }
        }
        }else{
          this.CheckArr.push(data)
        }
        let arr = []
        for(let val of this.CheckArr){
          arr.push(val.id)
        }
        this.projectIds = arr
        this.ShareList()
    },
    ChargevalueList(val){
      // console.log(val)
    },
     ChargeItem(){
        this.$http.get(this.$requestUrl.GET_ITEM_WEIGHT).then((res)=>{
            let arr = []
            for(let val of res.data.data){
                    let obj = {
                        "value":val.feeCode,
                        "label":val.feeName,
                    }
                    arr.push(obj)
                }
                this.ChargeItemList = arr
            
        })
    },
    handleSizeChange(val) {
        this.pagesize  = val
        this.ShareList()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.ShareList()
    },
    ShareList(){
      let obj = {
        "startSkrq": this.fromDate,
        "endSkrq":this.toDate,
        "projectIds":this.projectIds,
        "feeCodes": this.Chargevalue
      }
        this.$http.post(this.$requestUrl.POST_COLLECT_LIST,obj).then((res) => {
          let data = res.data;
          let arr =[]
          if (200 === data.code) {
          if(data.data.dayCollect.length == 0){
               this.$message({
            type: 'warning',
            message: '暂无数据！'
          });
          }else{
            // console.log(data.data.dayCollect)
             this.tableData = data.data.dayCollect
            this.DayCollectArr = data.data.dayCollect
            this.melistArr = data.data.melist
            this.coplistArr = data.data.coplist
          }
            this.STree()
            this.loading =false

          } else {
            this.loading = false
          }
        }).catch(() => {
           this.loading = false
        })
    },
    STree(){
        for(let i = 0 ; i<data.data.melist;i++){
              for(let j = 0 ; j<data.data.coplist;j++){
                for(let l = 0 ; l<data.data.dayCollect;l++){
                  data.data.melist[i].ms = data.data.coplist[j]
                    let obj = {
                      "projectName":data.data.dayCollect[0].projectName,
                      "feeName":data.data.dayCollect[0].feeName,

                    }
                }
              }
           }
    },
  },
  mounted() {
    this.ChargeItem()
  }
}
</script>

<style lang="scss">
.menuBody {
  .menuTool {
    .el-card {
      .el-card__body {
        padding: 10px 20px;
      }
    }

    margin-bottom: 10px;
  }

  .el-table {
    td {
      padding: 5px;
    }

    th {
      padding: 5px;
    }

    .success-row {
      background: #f0f9eb;


    }
  }

}
</style>